import React from 'react';
import './ResultsPageView.css';
import Loader from 'react-loader-spinner';
import ManageDialog from '../ManageDialog/ManageDialog';
import { Logo } from "../_components/Logo";
import RatingInputStar from "../VotePage/RatingInputStar/RatingInputStar";
import NotesPanel from "./NotesPanel/NotesPanel";
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

export const ResultsPageView = props => {
    const toNumberToZero = (v) => {
        const n = (typeof v === 'number') ? v : parseFloat(v);
        return Number.isFinite(n) ? n : 0;
    };

    const categories = props.categories?.length
        ? props.categories
        : (props.teams?.[0]?.categoryAverages?.map(c => ({
            id: c.categoryId,
            name: c.categoryName || ''
        })) ?? []);


    const cssVars = { '--cat-count': categories.length };

    const scoresList = (
        <div className="table-wrapper">
            <table className="ratings-table">
                <thead>
                    <tr>
                        <th className="team-col">Team</th>
                        <th className="overall-col">Overall</th>

                        {categories.map(c => (
                            <th key={c.id} className="cat-col">
                                {c.name}
                            </th>
                        ))}

                        <th className="notes-col">Notes</th>
                    </tr>
                </thead>

                <tbody>
                    {props.teams.map(t => (
                        <tr key={t.id}>
                            <td className="team-col">
                                <Logo source={t.logo} />
                            </td>

                            <td className="overall-col">
                                {Number(t.score) > 0
                                    ? (
                                        <RatingInputStar
                                            value={t.score ?? 0}
                                            edit={false}
                                            displayPrecision={2}
                                        />
                                    )
                                    : <span className="no-score">--</span>
                                }
                            </td>

                            {categories.map(c => {
                                const avg =
                                    t.categoryAverages?.find(x => x.categoryId === c.id)
                                        ?.average ?? 0
                                return (
                                    <td key={c.id} className="cat-col">
                                        {Number(avg) > 0
                                            ? (
                                                <RatingInputStar
                                                    value={Number(avg)}
                                                    edit={false}
                                                    displayPrecision={2}
                                                />
                                            )
                                            : <span className="no-score">--</span>
                                        }
                                    </td>
                                )
                            })}

                            <td className="notes-col">
                                <button
                                    className="btn btn-link view-link-button"
                                    onClick={() => props.toggleClass(t)}
                                >
                                    View ({t.notes?.length ?? 0})
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )

    const judgesList = props.judges.map(judge => (
        <div className="judge-status-item" key={judge.id}>
            <div className="judge-name-wrapper">
                <div className="judge-name" style={{ textTransform: 'capitalize' }}>{judge.name.split('@')[0]}</div>
            </div>
            <div className="team-status-bubbles">
                {judge.teamVotes.map(vote => {
                    let className = "status-bubble";
                    let tooltipContent = "";
                    const statusLetter = vote.teamName.charAt(0).toUpperCase();


                    tooltipContent = `<strong>${vote.teamName}</strong><ul>`;
                    if (vote.categoryVoteStatuses && vote.categoryVoteStatuses.length > 0) {
                        vote.categoryVoteStatuses.forEach(status => {
                            const checkmarkClass = status.hasVoted ? 'tooltip-checkmark has-voted' : 'tooltip-checkmark not-voted';
                            const checkmarkSymbol = '&#10004;';

                            tooltipContent += `<li>
                                <span class="${checkmarkClass}">${checkmarkSymbol}</span>
                                <span> ${status.categoryName} </span>
                            </li>`;
                        });
                    } else if (vote.completeStatus === 0) {
                        tooltipContent += `<li>Not started.</li>`;
                    } else if (vote.completeStatus === 2) {
                        tooltipContent += `<li>All categories rated.</li>`;
                    }
                    tooltipContent += `</ul>`;


                    if (vote.completeStatus === 2) {
                        className += ' status-bubble-completed';
                    } else if (vote.completeStatus === 1) {
                        className += ' status-bubble-partial';
                    } else {
                        className += ' status-bubble-not-started';
                    }

                    return (
                        <div
                            key={vote.teamId}
                            className={className}
                            data-tip={tooltipContent}
                            data-html={true}
                        >
                            {statusLetter}
                        </div>
                    );
                })}
            </div>
            <div className="view-scorecard-wrapper">

                <Link to={`/vote/${judge.id}`}>
                    <button
                        className="btn btn-link view-link-button"
                    >
                        View scorecard
                    </button>
                </Link>
            </div>
        </div>
    ));

    if (props.loading) return (
        <div className="spinner-container">
            <Loader type="TailSpin"
                color="#CF240A"
                height="60" width="60" />
        </div>
    );

    return (
        <div className="section-container">
            <div className="grid-wrap">
                <ManageDialog open={props.manageDialogOpen} onClose={props.hideManageDialog} />
                <div className="grid-main-header-top-row results-page-header">
                    <div className="header-column">
                        <div className="header-column-title"> Judges' Status</div>
                        <button
                            className="btn btn-primary result-header-button manage-button"
                            onClick={props.showManageDialog}
                        >
                            Manage Judges & Teams
                        </button>
                    </div>
                    <div className="header-column">
                        <div className="header-column-title result-title">Results</div>
                        <button
                            className="btn btn-primary result-header-button"
                            onClick={async (e) => {
                                e.preventDefault();
                                props.exportResults();
                            }}
                        >
                            Export Results Report
                        </button>
                    </div>

                </div>

                <div className="content-wrapper">
                    <div className="judges-column">
                        <div className="judges-list">
                            {judgesList}
                        </div>
                    </div>

                    <div className="vertical-divider"></div>
                    <div className="results-column">
                        <div className="results-list">
                            {scoresList}
                        </div>
                    </div>
                </div>

                <NotesPanel
                    isOpened={props.isOpened}
                    teamName={props.teamName}
                    notes={props.notes}
                    toggleClass={props.toggleClass}
                />
            </div>

        </div>
    );
};

export default ResultsPageView;